import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { TriangleAlert } from "lucide-react";
export function FormError({ message, className }) {
    if (!message)
        return null;
    return (_jsxs(Alert, { variant: "destructive", className: className, children: [_jsx(TriangleAlert, {}), _jsx(AlertDescription, { children: message })] }));
}
